import logger from '../utils/rbmc.logger';
import screen from '../utils/rbmc.screen'
import historyService from '../utils/rbmc.historyService';
//import plp from './rbmc.plp-services';

const browserBack = {
    backUrl: '',
    getCurrentBackUrl() {
        this.backUrl = $('#plp__grid').data('back-url');
    },
    setCurrentBackUrl(url) {
        this.backUrl = url;
    },
    readHistory() {
        let historyState = historyService.getState();

        if (historyState.productCode) {
            historyService.restorePos(historyState.scrollTop);
            if (!screen.isOnScreen('#' + historyState.productCode)) {
                logger.log('Product: ' + historyState.productCode + ' is not in viewport. Search for it');

                let targetProduct = $(`#${historyState.productCode}`);
                if (targetProduct.length) {
                    // 100 is the height of the sticky header (80px) plus some gap
                    historyService.restorePos(targetProduct.offset().top - 100)
                } else {
                    logger.log('Damn! Product: ' + historyState.productCode + ' is not on the page');
                }
            }
        }
    },
    bindHandler() {
        $(document.body).on('click', '.tile--listing', (evt) => {
            let productCode = $(evt.currentTarget).attr('id');

            historyService.replaceState({
                productCode: productCode,
                scrollTop:   $(window).scrollTop()
            }, this.backUrl);
        });
    }
};

$(() => {
    if (!$('#product-grid-page').hasClass('archibald-page')) {
        browserBack.getCurrentBackUrl();
        browserBack.readHistory();
        browserBack.bindHandler();
    }
});

export default browserBack;
